import { Product } from "../reducers/ProductsReducer";
import { RecActionType } from "../utils/actions";

export interface Recommendation {
  outfit: number[];
  score: number;
  metadata: Product[];
}

interface RecsState {
  styleRecsLoading: boolean;
  styleRecsError: boolean;
  styleRecommendations: Product[][];
}

interface RecsAction {
  type: RecActionType;
  payload?: Product[][];
}

const RecommendationReducer = (
  state: RecsState,
  action: RecsAction
): RecsState => {
  switch (action.type) {
    case RecActionType.GetStyleRecommendationBegin:
      return { ...state, styleRecsLoading: true };
    case RecActionType.GetStyleRecommendationSuccess:
      return {
        ...state,
        styleRecsLoading: false,
        styleRecommendations: action.payload!,
      };
    case RecActionType.GetStyleRecommendationError:
      return { ...state, styleRecsLoading: false, styleRecsError: true };
    default:
      return state;
  }
};

export default RecommendationReducer;
